export default __webpack_public_path__ + "static/media/icon-font.63eb89e4.woff";